import clsx from "clsx";
import { useEffect } from "react";
import { keycloak } from "../../lib/keycloak";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { colors } from "../../ui/colors";
import { PlusIcon } from "../../ui/icons/plus";
import Button from "../../ui/molecules/button";
import { SelectCustom } from "../../ui/molecules/select";
import { Spinner } from "../../ui/molecules/spinner";
import { ParticularityStatusEnum } from "./dto";
import {
  findAllParticularities,
  setParticularityToUpdate,
  setSelectedParticularity,
  setUpdateParticularityStatus,
  updateParticularityStatus
} from "./slice";

export function EditParticularityStatusModal() {
  const particularitiesState = useAppSelector((state) => state.particularities);

  const dispatch = useAppDispatch();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (
      particularitiesState.updateParticularityStatus === "failed" ||
      particularitiesState.updateParticularityStatus === "successfully"
    ) {
      dispatch(setSelectedParticularity(undefined));
      if (particularitiesState.updateParticularityStatus === "successfully") {
        dispatch(
          findAllParticularities({
            itemsPerPage: particularitiesState.filters.itemsPerPage,
            order: true,
            page: 0,
            sort: "name",
            name: ''
          })
        );
      }
      timeoutId = setTimeout(() => {
        dispatch(setUpdateParticularityStatus("idle"));
      }, 3000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [particularitiesState.updateParticularityStatus]);

  return (
    <div
      onClick={() => dispatch(setParticularityToUpdate(undefined))}
      className={clsx(
        "transition-all fixed bg-opacity-30 bg-neutral-950 backdrop-blur-sm top-0 left-0 h-full w-full flex items-center justify-center z-[100]",
        {
          block: particularitiesState.particularityToUpdate,
          hidden: !particularitiesState.particularityToUpdate,
        }
      )}
    >
      {particularitiesState.updateParticularityStatus === "loading" ? (
        <Spinner />
      ) : (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className="transition-all relative flex flex-col items-center bg-white rounded-[12px] opacity-100 shadow-sm min-w-[400px]"
        >
          <div
            onClick={() => dispatch(setParticularityToUpdate(undefined))}
            className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
          >
            <PlusIcon color={colors.brandPrimary[600]} size={16} />
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="p-6 text-heading-xs font-semibold text-center">
              Aggiorna stato
            </div>
          </div>
          <div className="px-6 py-8 w-full flex flex-col justify-center items-center gap-6 border-t-neutral-200 border-t">
            <div className="w-full">
              <SelectCustom
                placeholder={"Aggiorna stato"}
                defaultValue={particularitiesState.particularityToUpdate?.status!}
                menuPortalTargetIsNotBody
                onChange={e => {
                  dispatch(setParticularityToUpdate({
                    id: particularitiesState.particularityToUpdate?.id!,
                    status: e as ParticularityStatusEnum
                  }))
                }}
                options={[
                  {
                    value: ParticularityStatusEnum.ACTIVE,
                    label: "Attiva",
                  },
                  {
                    value: ParticularityStatusEnum.IDLE,
                    label: "Inattiva",
                  },
                  {
                    value: ParticularityStatusEnum.CANCELED,
                    label: "Cancellata",
                  }
                ]}
              />
            </div>
            <div className="w-full flex flex-1 gap-3">
              <div className="w-1/2">
                <Button
                  fullWidth
                  size={"sm"}
                  iconPosition={"off"}
                  variant={"outline"}
                  color={"gray"}
                  label="Annulla"
                  onClick={() => dispatch(setParticularityToUpdate(undefined))}
                />
              </div>
              <div className="w-1/2">
                <Button
                  fullWidth
                  size={"sm"}
                  disabled={keycloak.hasRealmRole("commercial")}
                  iconPosition={"off"}
                  variant={"solid"}
                  color={"blue"}
                  label="Conferma"
                  onClick={() => {
                    dispatch(
                      updateParticularityStatus({
                        data: particularitiesState.particularityToUpdate
                          ?.status!,
                        id: particularitiesState.particularityToUpdate?.id!,
                      })
                    );
                    dispatch(setParticularityToUpdate(undefined))
                  }
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
